/*
Copyright 2023, 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-NevaiCoffe-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";
import { Trans } from "react-i18next";

import { ExternalLink } from "../button/Link";

export const AnalyticsNotice: FC = () => (
  <Trans i18nKey="analytics_notice">
    By using NevaiCoffe, you consent to Nevai's collection of anonymous data for
    product improvement. See the{" "}
    <ExternalLink href="https://nevai.vercel.app/privacy">
      Nevai Privacy Policy
    </ExternalLink>
    for details.
  </Trans>
);
